import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { btnOutline, btnDeleteOutline } from './constants';

// Management 記錄頁的動作列。**勿在頁面各自寫一排裸按鈕**（`flex justify-end`
// 浮在標頭與內容卡之間、藍色實心 Edit ＋ 幽靈 Delete 那種）：既不在卡片裡、
// 樣式也跟十五條 workflow 詳情頁的動作列（`StatusActionsCard` 底列：
// outline ＋ icon）對不上。
//
// 這支就是 `StatusActionsCard` 的無狀態版：同一個白卡外殼、同兩顆按鈕樣式、
// 同一個位置（docs/workflow-ui.md §4.3 的 header 之後）。記錄頁沒有審核狀態，
// 所以卡裡只有動作；`children` 留給頁面塞自己的說明或額外按鈕。
const RecordActionsCard = ({
  onEdit,
  onDelete = null,
  editLabel = 'Edit',
  deleteLabel = 'Delete',
  deleteDisabled = false,
  deleteTitle = null,
  busy = false,
  children = null,
}) => (
  <div className="bg-white rounded-lg border border-slate-200 p-4 mb-4 flex flex-wrap items-center gap-2">
    {onEdit && (
      <button type="button" onClick={onEdit} disabled={busy} className={btnOutline}>
        <Pencil className="w-4 h-4" /> {editLabel}
      </button>
    )}
    {onDelete && (
      <button
        type="button"
        onClick={onDelete}
        disabled={busy || deleteDisabled}
        title={deleteTitle || undefined}
        className={`${btnDeleteOutline} disabled:cursor-not-allowed`}
      >
        <Trash2 className="w-4 h-4" /> {deleteLabel}
      </button>
    )}
    {children}
  </div>
);

export default RecordActionsCard;
